import * as React from 'react';

const Marker = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={84} height={86} viewBox="0 0 84 86" {...props}>
        <defs>
            <filter id="svgmarker_a" width="239.6%" height="239.6%" x="-69.8%" y="-49%" filterUnits="objectBoundingBox">
                <feOffset dy={10} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={9.5} />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0.0472862279 0 0 0 0 0.231790044 0 0 0 0 0.485252491 0 0 0 0.1 0"
                />
            </filter>
            <circle id="svgmarker_b" cx={24} cy={24} r={24} />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(18 9)">
                <use xlinkHref="#svgmarker_b" fill="currentColor" filter="url(#svgmarker_a)" />
                <use xlinkHref="#svgmarker_b" fill="#FFF" />
            </g>
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M51.6 29.8a.8.8 0 0 0-.311-.633l-8.8-6.8a.8.8 0 0 0-.98 0l-8.8 6.8a.8.8 0 0 0-.309.633v10.8a.8.8 0 0 0 .8.8h6.4a.4.4 0 0 0 .4-.4v-3.6a2 2 0 1 1 4 0V41c0 .22.18.4.4.4h6.4a.8.8 0 0 0 .8-.8z"
            />
        </g>
    </svg>
);
export default Marker;
